"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  helpDocumentationUri: null,
  hubSpotOwnedIntegrationStatus: null,
  iconUri: null,
  id: null,
  listingIconUri: null,
  listingWordmarkIconUri: null,
  name: null,
  nonIntegration: null,
  singleColorIconUri: null
}, 'Integration');

exports.default = _default;
module.exports = exports.default;